<script>
import { mapActions, mapState } from "vuex";
import { basketBase } from "./basketBase";

export default {
  mixins: [basketBase],
  props: {
    item: Object,
    isDuplicate: Boolean
  },
  computed: {
    ...mapState({
        meal_preferences: state => state.profile.meal_preferences
    }),
    recipe_price: function() {
        return (this.item.recipe.fractional_prices_for_portions[this.meal_preferences.people]/100)
    },
    per_person: function() {
        return this.recipe_price / this.meal_preferences.people;
    }
  }
};
</script>

<template>
  <div class="basket-list-item">
    <div class="image">
      <img :src="item.image" width="100%">
    </div>
    <div class="meta">
      <div>{{ item.name }}</div>
      <div v-if="item.recipe">
        <div class="recipe-details">
            <div class="recipe-macros">
                <span class="macro calories"><span class="label">Calories: </span>{{ item.recipe.macros.calories }}</span>
                <span class="macro cook-time">&nbsp;<span class="label">Time: </span>{{ item.recipe.cooking_time_in_minutes }}min</span>
            </div>
            <div class="recipe-price">
                <span v-mny="{ input: recipe_price, currency: 'GBP' }"></span>
                <span> for {{ meal_preferences.people }} {{ meal_preferences.people | persons }} </span>
                <span class="per-person" v-if="per_person!=recipe_price">(<span v-mny="{ input: per_person, currency: 'GBP' }"></span>&nbsp;per person)</span>
            </div>
        </div>
      </div>
      <div v-if="isDuplicate">
        <b-badge variant="warning">You have selected this item more than once.</b-badge>
      </div>
    </div>
    <div class="actions">
      <button @click="removeFromBasket(item)" class="btn cta-button btn-secondary btn-block">Remove</button>
    </div>
  </div>
</template>
